import { types } from "mobx-state-tree";
import { withSetPropAction } from "../../_extension/with-set-props";
export const ValidationErrorStore = types
  .model({
    show: false,
    errorMessage: "",
  })
  .actions(withSetPropAction);
